export default __webpack_public_path__ + "static/Aeonik-Air-e72a0cf9cc8411371947221b3c2fa665.otf";